export default {
    CANCELLED_RESPONSE_CODE: 'CANCELLED',
    STATUS_SUCCESS: 'SUCCESS',
    STATUS_ERROR: 'ERROR',
    ENDPOINT: '/api',
    HEADERS: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    TIMEOUT: 80000,
};
